<ng-container *ngIf="activeUser$ | async as activeUser">
  <ng-container *ngrxLet="businessPlan$ as businessPlan">
    <div class="officer-resolution-request-wrapper">
      <h1
        mat-dialog-title
        class="mb-0 !text-[2.2rem] text-center text-darkGray"
      >
        {{ isEditMode() ? "Edit" : "Add New" }}&nbsp;
        {{activeUser.getFullName()}} Detail
        <span *ngIf="isDirector()">Director</span>
        <span *ngIf="isShareholder()">Shareholder</span>
      </h1>
      <div
        class="officer-container !-mx-6 p-4 !pt-0 relative"
        *ngIf="officerRequestState"
      >
        <div class="absolute top-1.5 left-10 text-base text-[#3A4856] font-semibold">
          {{ isDirector() ? "Director" : "Shareholder" }} Information:
        </div>
        <mat-stepper #stepper linear class="officer-container-stepper">
          <mat-step
            [label]="
              (isEditMode() ? 'Edit' : 'Add') +
              ' ' +
              (isDirector() ? 'Director' : 'Shareholder')
            "
            [stepControl]="officerRequestState.formInput.officerForm"
          >
            <mat-dialog-content class="!pt-5">
              <div *ngIf="!activeUser.isCustomer()">
                <mat-form-field appearance="outline" class="w-1/3">
                  <mat-label>Effective date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="effectiveDatePicker"
                    [formControl]="officerRequestState.effectiveDate"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="effectiveDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #effectiveDatePicker></mat-datepicker>
                </mat-form-field>
                <mat-divider class="!mb-6 !mx-auto"></mat-divider>
              </div>
              <!--USE DETAIL OF-->
              <ng-container *ngIf="!isEditMode()">
                <div
                  class="flex flex-col"
                  [ngClass]="{ 'mb-4': showExistingOfficer() }"
                >
                  <p class="mat-title !text-base !mb-2 text-darkGray">
                    Choose a
                    <span *ngIf="isDirector()">director</span>
                    <span *ngIf="isShareholder()">shareholder</span>
                  </p>
                  <mat-radio-group
                    aria-label="Select an option"
                    class="group-selection mb-4 inline-flex"
                    [(ngModel)]="selectedDetailMode"
                    (change)="onDetailModeChange($event)"
                  >
                    <mat-radio-button
                      class="select-option mr-4 !transform:capitalize"
                      *ngFor="let option of detailModeOptions"
                      [value]="option.value"
                    >
                      <p
                        class="mat-subheading-1 text-darkGray !mb-0 text-transform: capitalize"
                      >
                        {{ option.label }}
                      </p>
                    </mat-radio-button>
                  </mat-radio-group>

                  <ng-container *ngIf="showExistingOfficer()">
                    <p class="mat-title !text-base text-darkGray !mb-2">
                      Use Detail of
                    </p>
                    <!-- <mat-form-field appearance="outline" class="w-1/3"> -->
                    <!--   <input type="text" matInput placeholder="existing" /> -->
                    <!-- </mat-form-field> -->
                    <app-exists-officers-select
                      [countryOfIncorporation]="supportedCountry"
                      [existingOfficers]="
                        officerRequestState.existingOfficerState
                          .existingOfficers
                      "
                      [selectedOfficerId]="
                        officerRequestState.existingOfficerState
                          .selectedOfficerId
                      "
                      [excludedOfficerIds]="
                        officerRequestState.existingOfficerState
                          .excludedOfficerIds || []
                      "
                      (existingOfficerSelected)="
                        onExistingOfficerSelected($event)
                      "
                    ></app-exists-officers-select>

                    <mat-divider class="!mx-auto"></mat-divider>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngIf="activeUser.isExpert() && !isEditMode()">
                <div class="text-center mb-2">
                  <button
                    mat-raised-button
                    color="accent"
                    (click)="openLookupOfficerDialog()"
                  >
                    Lookup officers
                  </button>
                </div>
              </ng-container>

              <!--Officer Type-->
              <div
                class="flex flex-col mb-4"
                [formGroup]="officerRequestState.formInput.officerForm"
              >
                <mat-form-field appearance="outline" class="w-1/3" *ngIf="!data.selectedOfficer">
                  <mat-label>Type</mat-label>
                  <mat-select
                    class="capitalize"
                    [(value)]="selectedOfficerType"
                    [disabled]="isOfficerTypeSelectDisabled()"
                    (selectionChange)="onOfficerTypeChange($event)"
                  >
                    <mat-option
                      *ngFor="
                        let type of officerRequestState.getAvailableOfficerTypes()
                      "
                      [value]="type"
                      [disabled]="isOfficerTypeDisabled(type)"
                      class="capitalize"
                    >
                      {{ type.toLowerCase() }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <!--Officer INPUT FORM-->
                <app-individual-info
                  *ngIf="
                    selectedOfficerType === OfficerTypeEnum.Individual ||
                    selectedOfficerType === OfficerTypeEnum.Nominee
                  "
                  [formGroup]="
                    officerRequestState.formInput.officerForm
                  "
                  [countryOfIncorporationOverride]="supportedCountry$ | async"
                  #officerPersonForm
                ></app-individual-info>
                <app-corporate-info
                  *ngIf="selectedOfficerType === OfficerTypeEnum.Corporate"
                  [showTypeSelected]="!!data.selectedOfficer"
                  [formGroup]="
                    officerRequestState.formInput.officerForm
                  "
                  #officerCompanyForm
                ></app-corporate-info>

                <!--Officer KYC DOCUMENTS-->
                <!-- <ng-container *ngIf="typeSelected !== OfficerTypeEnum.Nominee"> -->
                <!--   <mat-divider class="!my-2 !mx-auto !w-1/2"></mat-divider> -->
                <!---->
                <!--   <p class="mat-title !text-base !mb-3 text-darkGray"> -->
                <!--     Require documents -->
                <!--   </p> -->
                <!--   <ng-container *ngIf=" -->
                <!--       activeUser.isCustomer() && isEditMode() && isDirector() -->
                <!--     "> -->
                <!--     <app-callout class="block mb-3" *ngIf="companyProfile.country.code === 'SG'" -->
                <!--       message="It is mandatory to update the ACRA for any change of the director’s place of residence or passport. Please note that you have to notify the ACRA of any change of a director’s particulars within 14 days to avoid any penalty." -->
                <!--       appearance="warn"> -->
                <!--     </app-callout> -->
                <!---->
                <!--     <app-callout class="block mb-3" *ngIf="companyProfile.country.code === 'HK'" -->
                <!--       message="It is mandatory to update the Companies Registry (CR) for any change in particulars of directors. Please note that you have to notify the CR within 15 days after the date of change to avoid any penalty" -->
                <!--       appearance="warn"> -->
                <!--     </app-callout> -->
                <!--   </ng-container> -->
                <!--   <div class="grid gap-4" [ngClass]="{ -->
                <!--       'grid-cols-2': -->
                <!--         typeSelected === OfficerTypeEnum.Individual, -->
                <!--       'grid-cols-3': typeSelected === OfficerTypeEnum.Corporate -->
                <!--     }"> -->
                <!--     <div *ngFor=" -->
                <!--         let document of officerRequestState.requireDocuments -->
                <!--       " class="flex flex-col"> -->
                <!--       <p class="!mb-1 inline-flex items-center"> -->
                <!--         <span class="mat-subheading-1 text-sub !mb-0 !mr-2">{{ -->
                <!--           startCase(document.toLowerCase()) -->
                <!--           }}</span> -->
                <!--         <mat-icon *ngIf="typeSelected === OfficerTypeEnum.Individual" -->
                <!--           class="text-darkGray opacity-80 !text-base" matTooltip="{{ -->
                <!--             commonHelper.getDocumentHint(document) -->
                <!--           }}">info -->
                <!--         </mat-icon> -->
                <!--       </p> -->
                <!--       <app-dropzone-upload (filesChanged)=" -->
                <!--           officerRequestState.fileChanged( -->
                <!--             $event, -->
                <!--             document -->
                <!--           ) -->
                <!--         " accept="application/pdf,image/*" -->
                <!--         label="Upload {{ startCase(document.toLowerCase()) }}"></app-dropzone-upload> -->
                <!--     </div> -->
                <!--   </div> -->
                <!-- </ng-container> -->
              </div>
            </mat-dialog-content>
            <mat-dialog-actions>
              <div class="w-full flex flex-row justify-between">
                <section>
                  <button
                    mat-raised-button
                    class="w-52 bg-grey-800 text-white"
                    (click)="onCloseDialog()"
                  >
                    Cancel
                  </button>
                </section>
                <section>
                  <button
                    mat-button
                    color="accent"
                    class="w-52 mr-3"
                    (click)="resetForm()"
                  >
                    Reset form
                  </button>
                  <button
                    mat-raised-button
                    class="w-52"
                    color="primary"
                    (click)="onReviewRequest()"
                    [disabled]="!officerRequestState.isFormValid()"
                    matStepperNext
                  >
                    Next
                  </button>
                </section>
              </div>
            </mat-dialog-actions>
          </mat-step>

          <mat-step label="Review request">
            <mat-dialog-content *ngIf="stepper.selectedIndex === 1" class="!pt-5">
              <app-callout
                *ngIf="activeUser.isCustomer() && !isEditMode()"
                message="All the information will be reviewed by a corporate expert and double checked with you the new officer registration."
                appearance="warn"
                class="block mb-4"
              ></app-callout>

              <app-callout
                *ngIf="activeUser.isCustomer() && isEditMode()"
                message="All the information will be reviewed by a corporate expert and double checked with you on changing officer information."
                appearance="warn"
                class="block mb-4"
              ></app-callout>

              <!--TODO USE IT FOR ADD NEW OFFICER  - DISPLAY NEW OFFICER INFORMATION-->
              <ng-container *ngIf="!isEditMode()">
                <ng-container *ngIf="isNominee()">
                  <p
                    class="mat-title !text-base !mb-2 p-2 text-primary-900 bg-grey-50"
                  >
                    New
                    {{
                      isDirector()
                        ? "director"
                        : isShareholder()
                          ? "shareholder"
                          : ""
                    }}
                    information
                  </p>
                  <p>Nominee {{ isDirector() ? "director" : "" }}</p>
                </ng-container>
                <ng-container *ngIf="!isNominee()">
                  <p
                    class="mat-title !text-base !mb-2 p-2 text-primary-900 bg-grey-50"
                  >
                    New
                    {{
                      isDirector()
                        ? "director"
                        : isShareholder()
                          ? "shareholder"
                          : ""
                    }}
                    information
                  </p>
                  <app-officer-input-review-information
                    *ngIf="officerRequestState.isFormValid()"
                    [officerType]="getFormType()"
                    [formType]="officerRequestState.selectedOfficerType"
                    [officerInput]="officerRequestState.getFormValue()"
                  ></app-officer-input-review-information>
                </ng-container>
              </ng-container>

              <!--TODO USE IT FOR EDIT OFFICER INFORMATION  - DISPLAY OLD & NEW INFORMATION-->
              <ng-container *ngIf="isEditMode() && !isNominee()">
                <section class="mb-4">
                  <p
                    class="mat-title !text-base !mb-2 p-2 text-primary-900 bg-grey-50"
                  >
                    Current
                    {{
                      isDirector()
                        ? "director"
                        : isShareholder()
                          ? "shareholder"
                          : ""
                    }}
                    information
                  </p>
                  <app-officer-input-review-information
                    *ngIf="officerRequestState.isFormValid()"
                    [officerType]="getFormType()"
                    [formType]="officerRequestState.selectedOfficerType"
                    [officerInput]="getOldOfficerInputValue()"
                  ></app-officer-input-review-information>
                </section>
                <section>
                  <p
                    class="mat-title !text-base !mb-2 p-2 text-primary-900 bg-grey-50"
                  >
                    New
                    {{
                      isDirector()
                        ? "director"
                        : isShareholder()
                          ? "shareholder"
                          : ""
                    }}
                    information
                  </p>
                  <app-officer-input-review-information
                    *ngIf="officerRequestState.isFormValid()"
                    [officerType]="getFormType()"
                    [formType]="officerRequestState.selectedOfficerType"
                    [officerInput]="officerRequestState.getFormValue()"
                  ></app-officer-input-review-information>
                </section>
              </ng-container>
            </mat-dialog-content>
            <mat-dialog-actions
              align="center"
              *ngIf="stepper.selectedIndex === 1"
            >
              <button
                mat-raised-button
                class="w-52 bg-grey-800 text-white"
                matStepperPrevious
              >
                Back
              </button>
              <button
                mat-raised-button
                class="w-52"
                color="primary"
                (click)="onSubmitRequest()"
                [disabled]="
                  (officerRequestState.postStatus$ | async) ===
                  'SUBMITTING'
                "
              >
                <span *ngIf="!activeUser.isCustomer()">Submit</span>
                <span
                  *ngIf="businessPlan?.isPremium() && activeUser.isCustomer()"
                >
                  Place order
                </span>
                <span
                  *ngIf="!businessPlan?.isPremium() && activeUser.isCustomer()"
                >
                  Submit Request
                </span>
              </button>
            </mat-dialog-actions>
          </mat-step>
        </mat-stepper>
      </div>
    </div>
  </ng-container>
</ng-container>
